import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";
import {UserModule} from "@/store/modules/user";

Vue.use(Router);

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export default new Router({
    // mode: 'history',  // Enable this if you need.
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/login",
            component: () => import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
            meta: { hidden: true }
        },
        {
            path: "/verify",
            component: () => import(/* webpackChunkName: "login" */ "@/views/login/verify.vue"),
            meta: { hidden: true }
        },
        {
            path: "/404",
            component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
            meta: { hidden: true }
        },
        {
            path: "/",
            component: Layout,
            redirect: "/customer/list",
            children: [
                {
                    path: "customer/list",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/tasks/CustomerList.vue"),
                    meta: {
                        title: "客户管理",
                        icon: "user"
                    }
                }
            ]
        },
        {
            path: "/project",
            component: Layout,
            redirect: "/project/list",
            children: [
                {
                    path: "list",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/tasks/ProjectList.vue"),
                    meta: {
                        title: "工程管理",
                        icon: "dashboard"
                    }
                }
            ]
        },
        {
            path: "/task",
            component: Layout,
            children: [
                {
                    path: "list",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/tasks/TaskList.vue"),
                    meta: {
                        title: "任务管理",
                        icon: "form"
                    }
                }
            ]
        },
        {
            path: "/burn_device",
            component: Layout,
            redirect: "/burn_device/list",
            meta: {
                title: "烧录设备",
                icon: "nested"
            },
            children: [
                {
                    path: "list",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/burn_device/BurnDeviceList.vue"),
                    meta: {
                        title: "烧录设备管理",
                        icon: "example"
                    }
                },
                {
                    path: "tasks",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/burn_device/BurnDeviceTaskList.vue"),
                    meta: {
                        title: "烧录设备任务",
                        icon: "example"
                    }
                }
            ]
        },
        {
            path: "/logs",
            component: Layout,
            children: [
                {
                    path: "index",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/log/Log.vue"),
                    meta: {
                        title: "日志",
                        icon: "form"
                    }
                }
            ]
        },
        // {
        //     path: "/example",
        //     component: Layout,
        //     redirect: "/example/tree",
        //     meta: {
        //         title: "Example",
        //         icon: "example"
        //     },
        //     children: [
        //         {
        //             path: "tree",
        //             component: () => import(/* webpackChunkName: "tree" */ "@/views/tree/index.vue"),
        //             meta: {
        //                 title: "Tree",
        //                 icon: "tree"
        //             }
        //         },
        //         {
        //             path: "table",
        //             component: () => import(/* webpackChunkName: "table" */ "@/views/table/index.vue"),
        //             meta: {
        //                 title: "Table",
        //                 icon: "table"
        //             }
        //         }
        //     ]
        // },
        // {
        //     path: "/form",
        //     component: Layout,
        //     children: [
        //         {
        //             path: "index",
        //             component: () => import(/* webpackChunkName: "form" */ "@/views/form/index.vue"),
        //             meta: {
        //                 title: "ttt",
        //                 icon: "form"
        //             }
        //         }
        //     ]
        // },
        {
            path: "/keys",
            component: Layout,
            children: [
                {
                    path: "index",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/keys/KeyManager.vue"),
                    meta: {
                        title: "密钥管理",
                        icon: "password"
                    }
                }
            ]
        },
        {
            path: "/print",
            component: Layout,
            redirect: "/print/PrintUsers",
            meta: {
                title: "打印机",
                icon: "nested"
            },
            children: [
                {
                    path: "PrintUsers",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/print/PrintUsers.vue"),
                    meta: {
                        title: "用户统计",
                        icon: "form"
                    }
                },
                {
                    path: "VList",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/print/VList.vue"),
                    meta: {
                        title: "VID&PID",
                        icon: "form"
                    }
                },
                {
                    path: "PrintData",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/print/PrintData.vue"),
                    meta: {
                        title: "打印数据",
                        icon: "form"
                    }
                }
            ]
        },
        {
            path: "/users",
            component: Layout,
            redirect: "/users/list",
            meta: {
                title: "用户管理",
                icon: "user"
            },
            children: [
                {
                    path: "list",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/users/UserList.vue"),
                    meta: {
                        title: "用户列表",
                        icon: "form"
                    }
                },
                {
                    path: "modify_pswd",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/users/ModifyPassword.vue"),
                    meta: {
                        title: "修改密码",
                        icon: "form"
                    }
                },
                {
                    path: "modify_phone",
                    component: () => import(/* webpackChunkName: "form" */ "@/views/users/ModifyPhone.vue"),
                    meta: {
                        title: "修改电话",
                        icon: "form"
                    }
                }
            ]
        },
        // {
        //     path: "/nested",
        //     component: Layout,
        //     redirect: "/nested/menu1",
        //     meta: {
        //         title: "Nested",
        //         icon: "nested"
        //     },
        //     children: [
        //         {
        //             path: "menu1",
        //             component: () => import(/* webpackChunkName: "menu1" */ "@/views/nested/menu1/index.vue"),
        //             redirect: "/nested/menu1/menu1-1",
        //             meta: { title: "Menu1" },
        //             children: [
        //                 {
        //                     path: "menu1-1",
        //                     component: () => import(/* webpackChunkName: "menu1-1" */ "@/views/nested/menu1/menu1-1/index.vue"),
        //                     meta: { title: "Menu1-1" }
        //                 },
        //                 {
        //                     path: "menu1-2",
        //                     component: () => import(/* webpackChunkName: "menu1-2" */ "@/views/nested/menu1/menu1-2/index.vue"),
        //                     redirect: "/nested/menu1/menu1-2/menu1-2-1",
        //                     meta: { title: "Menu1-2" },
        //                     children: [
        //                         {
        //                             path: "menu1-2-1",
        //                             component: () => import(/* webpackChunkName: "menu1-2-1" */ "@/views/nested/menu1/menu1-2/menu1-2-1/index.vue"),
        //                             meta: { title: "Menu1-2-1" }
        //                         },
        //                         {
        //                             path: "menu1-2-2",
        //                             component: () => import(/* webpackChunkName: "menu1-2-2" */ "@/views/nested/menu1/menu1-2/menu1-2-2/index.vue"),
        //                             meta: { title: "Menu1-2-2" }
        //                         }
        //                     ]
        //                 },
        //                 {
        //                     path: "menu1-3",
        //                     component: () => import(/* webpackChunkName: "menu1-3" */ "@/views/nested/menu1/menu1-3/index.vue"),
        //                     meta: { title: "Menu1-3" }
        //                 }
        //             ]
        //         },
        //         {
        //             path: "menu2",
        //             component: () => import(/* webpackChunkName: "menu2" */ "@/views/nested/menu2/index.vue"),
        //             meta: { title: "Menu2" }
        //         }
        //     ]
        // },
        // {
        //     path: "external-link",
        //     component: Layout,
        //     children: [
        //         {
        //             path: "https://github.com/Armour/vue-typescript-admin-template",
        //             meta: {
        //                 title: "External Link",
        //                 icon: "link"
        //             }
        //         }
        //     ]
        // },
        {
            path: "*",
            redirect: "/404",
            meta: { hidden: true }
        }
    ]
});
